import { getCountries, getCountryCallingCode } from 'react-phone-number-input'
import countryLabels from 'react-phone-number-input/locale/en.json'

/** Sorted, English-named ISO 3166-1 country list pulled from the
 *  `react-phone-number-input` metadata. Computed once at module load so
 *  every consumer reuses the same array instead of re-sorting 245 rows.
 *
 *  Lives here (not inside `CountryFilter.jsx`) so non-component consumers
 *  — e.g. the Create Company form's country <select> — can import it
 *  without tripping react-refresh's "only export components" rule.
 *
 *  Each entry carries the alpha-2 code (matches what the backend expects),
 *  the English label (e.g. "United Arab Emirates"), and the dial code. */
export const ALL_COUNTRIES = (() => {
  const rows = getCountries().map((code) => {
    let dial = ''
    try {
      dial = getCountryCallingCode(code)
    } catch {
      // A few entries don't have a dial code (e.g. some dependencies).
      // Leave dial blank — the row still works.
    }
    return {
      code,
      name: countryLabels[code] ?? code,
      dial,
    }
  })
  // Alphabetical by English name — matches what a Master Admin scanning
  // the list expects (no non-English collation surprises).
  rows.sort((a, b) => a.name.localeCompare(b.name))
  return rows
})()
